import { Navigate, useLocation } from 'react-router-dom';

const KEY = import.meta.env.VITE_TOKEN_STORAGE_KEY || 'auth_token';

function hasToken() {
  return localStorage.getItem(KEY) || sessionStorage.getItem(KEY) || localStorage.getItem('auth_token');
}

export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!hasToken()) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}
